"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._getPossibleFirstTouchMetadata = exports._getNetworkInfo = exports._gatherAllMetadata = exports._gatherCommonMetadata = void 0;
const client_core_1 = require("@statsig/client-core");
const commonUtils_1 = require("./commonUtils");
function _gatherCommonMetadata(url) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const safeDoc = (0, client_core_1._getDocumentSafe)();
    const safeWnd = (0, client_core_1._getWindowSafe)();
    return (0, commonUtils_1._stripEmptyValues)(Object.assign({ title: safeDoc === null || safeDoc === void 0 ? void 0 : safeDoc.title, current_url: (_a = safeWnd === null || safeWnd === void 0 ? void 0 : safeWnd.location) === null || _a === void 0 ? void 0 : _a.href, user_agent: ((_b = safeWnd === null || safeWnd === void 0 ? void 0 : safeWnd.navigator) === null || _b === void 0 ? void 0 : _b.userAgent) &&
            ((_d = (_c = safeWnd === null || safeWnd === void 0 ? void 0 : safeWnd.navigator) === null || _c === void 0 ? void 0 : _c.userAgent) === null || _d === void 0 ? void 0 : _d.length) > 200
            ? safeWnd.navigator.userAgent.substring(0, 200)
            : (_e = safeWnd === null || safeWnd === void 0 ? void 0 : safeWnd.navigator) === null || _e === void 0 ? void 0 : _e.userAgent, locale: (_f = safeWnd === null || safeWnd === void 0 ? void 0 : safeWnd.navigator) === null || _f === void 0 ? void 0 : _f.language, hostname: url.hostname, pathname: url.pathname, screen_width: (_g = safeWnd === null || safeWnd === void 0 ? void 0 : safeWnd.screen) === null || _g === void 0 ? void 0 : _g.width, screen_height: (_h = safeWnd === null || safeWnd === void 0 ? void 0 : safeWnd.screen) === null || _h === void 0 ? void 0 : _h.height, viewport_width: safeWnd === null || safeWnd === void 0 ? void 0 : safeWnd.innerWidth, viewport_height: safeWnd === null || safeWnd === void 0 ? void 0 : safeWnd.innerHeight, viewport: `${safeWnd === null || safeWnd === void 0 ? void 0 : safeWnd.innerWidth}x${safeWnd === null || safeWnd === void 0 ? void 0 : safeWnd.innerHeight}`, timestamp: Date.now(), timezone: (0, commonUtils_1._getSafeTimezone)(), timezone_offset: (0, commonUtils_1._getSafeTimezoneOffset)(), navigation_type: (0, commonUtils_1._getSafeNavigationType)() }, _getNetworkInfo()));
}
exports._gatherCommonMetadata = _gatherCommonMetadata;
function _gatherAllMetadata(url) {
    const safeDoc = (0, client_core_1._getDocumentSafe)();
    const safeWnd = (0, client_core_1._getWindowSafe)();
    if (!safeDoc || !safeWnd) {
        return {};
    }
    const referrerInfo = getReferrerInfo(safeDoc);
    const commonInfo = _gatherCommonMetadata(url);
    const campaignParams = getCampaignParams(url);
    const queryParams = {};
    url.searchParams.forEach((v, k) => {
        queryParams[k] = v;
    });
    return Object.assign(Object.assign({}, commonInfo), (0, commonUtils_1._stripEmptyValues)(Object.assign(Object.assign(Object.assign({}, referrerInfo), campaignParams), queryParams)));
}
exports._gatherAllMetadata = _gatherAllMetadata;
function _getNetworkInfo() {
    const networkInfo = (0, commonUtils_1._getSafeNetworkInformation)();
    const result = {};
    if ((networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.effectiveType) !== undefined) {
        result['effective_connection_type'] = networkInfo.effectiveType;
    }
    if ((networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.rtt) !== undefined) {
        result['rtt_ms'] = networkInfo.rtt;
    }
    if ((networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.downlink) !== undefined) {
        result['downlink_mbps'] = networkInfo.downlink;
        result['downlink_kbps'] = networkInfo.downlink * 1000; // deprecated
    }
    if ((networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.saveData) !== undefined) {
        result['save_data'] = networkInfo.saveData;
    }
    return result;
}
exports._getNetworkInfo = _getNetworkInfo;
function _getPossibleFirstTouchMetadata(url) {
    const safeDoc = (0, client_core_1._getDocumentSafe)();
    const safeWnd = (0, client_core_1._getWindowSafe)();
    if (!safeDoc || !safeWnd) {
        return {};
    }
    const referrerInfo = getReferrerInfo(safeDoc);
    const campaignParams = getCampaignParams(url);
    const combined = (0, commonUtils_1._stripEmptyValues)(Object.assign(Object.assign({}, referrerInfo), campaignParams));
    const prefixed = {};
    for (const [key, value] of Object.entries(combined)) {
        prefixed[`$s_${key}`] = value;
    }
    return prefixed;
}
exports._getPossibleFirstTouchMetadata = _getPossibleFirstTouchMetadata;
function getReferrerInfo(safeDoc) {
    const referrer = (safeDoc === null || safeDoc === void 0 ? void 0 : safeDoc.referrer) || '';
    if (!referrer) {
        return {
            referrer: null,
            referrer_domain: null,
            referrer_path: null,
            searchEngine: '',
            searchQuery: '',
        };
    }
    try {
        const url = new URL(referrer);
        const host = url.hostname;
        const searchEngine = ['google', 'bing', 'yahoo', 'duckduckgo', 'baidu'].find((e) => host.includes(e + '.')) || '';
        const searchQuery = url.searchParams.get(searchEngine === 'yahoo' ? 'p' : 'q') || '';
        return {
            referrer,
            referrer_domain: url.hostname,
            referrer_path: url.pathname,
            searchEngine,
            searchQuery,
        };
    }
    catch (e) {
        return {
            referrer: null,
            referrer_domain: null,
            referrer_path: null,
            searchEngine: '',
            searchQuery: '',
        };
    }
}
function getCampaignParams(url) {
    const urlParams = url.searchParams;
    const campaignParams = {};
    const commonUtms = [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_term',
        'utm_content',
        'msclkid', // Bing
        'dclid', // DoubleClick
        'fbclid', // Facebook
        'gad_source', // Google
        'gclid', // Google
        'gclsrc', // Google
        'wbraid', // Google
        'utm_id', // Hubspot
        'irclid', // Impact
        'igshid', // Instagram
        '_kx', // Klaviyo
        'li_fat_id', // LinkedIn
        'mc_cid', // Mailchimp
        'mc_eid', // Mailchimp
        'epik', // Pinterest
        'qclid', // Quora
        'rdt_cid', // Reddit
        'sccid', // Snapchat
        'ttc', // TikTok
        'ttclid', // TikTok
        'ttc_id', // TikTok
        'twclid', // Twitter
    ];
    commonUtms.forEach((p) => {
        const val = urlParams.get(p);
        if (val) {
            campaignParams[p] = val;
        }
    });
    return campaignParams;
}
